export enum ProviderLoader {
    isProvidersLoading,
    isProviderContractorUpdateLoading
}